import { getGoodsDetail } from './getGoodsDetail';
import { getGoodsBasic } from './getGoodsBasic';
import { getSimilarGoods } from './getSimilarGoods';
import { getGoodsDiscounts } from './getGoodsDiscounts';
import { getGoodsCoupons } from './getGoodsCoupons';
import { postRedeemAllGoodsCoupon } from './postRedeemAllGoodsCoupon';
import { getGoodsReviewSummary } from './getGoodsReviewSummary';
import { getCodiGoods } from './getCodiGoods';
import { getMidRelatedAdGoods } from './getMidRelatedAdGoods';
import { getRelatedOutfits } from './getRelatedOutfits';
import { getGoodsCoupon } from './getGoodsCoupon';
import { getGoodsAwards } from './getGoodsAwards';
import { getGoodsLikeRecommend } from './getGoodsLikeRecommend';
import { getGoodsOptions } from './getGoodsOptions';
import { getGoodsOptionsBrief } from './getGoodsOptionsBrief';
import { postGoodsOptionsPricing } from './postGoodsOptionsPricing';
import { postRestockNotification } from './postRestockNotification';
import { postApplyDiscounts } from './postApplyDiscounts';
import { getGoodsReviewsSummary } from './getGoodsReviewsSummary';
import { getGoodsReviewsPhotoFeeds } from './getGoodsReviewsPhotoFeeds';
import { getGoodsReviews } from './getGoodsReviews';
import { getGoodsReviewsMetadata } from './getGoodsReviewsMetadata';
import { getGoodsReviewsAvailableInfo } from './getGoodsReviewsAvailableInfo';
import { getGoodsPieces } from './getGoodsPieces';
import { getGoodsLegalNotice } from './getGoodsLegalNotice';
import { getGoodsPIPNInfo } from './getGoodsPIPNInfo';
import { getGoodsSellerInfo } from './getGoodsSellerInfo';
import { getGoodsModelInfo } from './getGoodsModelInfo';
import { getRelatedLiveCampaign } from './getRelatedLiveCampaign';
import { postParticipateLiveCampaign } from './postParticipateLiveCampaign';
import { getBeautyRecommendedOption } from './getBeautyRecommendedOption';
import { getSizeReviewAnalysis } from './getSizeReviewAnalysis';
import { getRankingFilters } from './getRankingFilters';
import { getRankingGoods } from './getRankingGoods';
import { getGoodsList } from './getGoodsList';

export const goodsService = {
  getGoodsDetail,
  getGoodsBasic,
  getSimilarGoods,
  getGoodsDiscounts,
  getGoodsCoupons,
  postRedeemAllGoodsCoupon,
  getGoodsReviewSummary,
  getGoodsReviewsSummary,
  getCodiGoods,
  getMidRelatedAdGoods,
  getRelatedOutfits,
  getGoodsCoupon,
  getGoodsAwards,
  getGoodsLikeRecommend,
  getGoodsOptions,
  getGoodsOptionsBrief,
  postGoodsOptionsPricing,
  postRestockNotification,
  postApplyDiscounts,
  getGoodsReviewsPhotoFeeds,
  getGoodsReviews,
  getGoodsReviewsMetadata,
  getGoodsReviewsAvailableInfo,
  getGoodsPieces,
  getGoodsLegalNotice,
  getGoodsPIPNInfo,
  getGoodsSellerInfo,
  getGoodsModelInfo,
  getRelatedLiveCampaign,
  postParticipateLiveCampaign,
  getBeautyRecommendedOption,
  getSizeReviewAnalysis,
  getRankingFilters,
  getRankingGoods,
  getGoodsList,
};
